<nz-spin [nzSpinning]="cardLoading">
  <section>
    <div>
      <nz-page-header nzBackIcon class="bg-slate-100" [nzGhost]="false">
        <nz-page-header-title class="text-primary">
        {{ this.tourRef }} - {{ 'itineraries.viewStatusLog.title' | transloco }}
        </nz-page-header-title>
      </nz-page-header>
    </div>
    <div class="my-4">
      <nz-table
        #basicTable
        [nzData]="allCustomers"
        [nzShowSizeChanger]="pageSize.length > 5"
        [nzPageSizeOptions]="pageSize.pageSizeOptions"
        [nzBordered]="true"
        [nzFrontPagination]="false"
        [nzTotal]="pageSize.length"
        [nzPageSize]="pageSize.pageSize"
        [nzPageIndex]="pageSize.pageIndex"
        (nzQueryParams)="onTableParamsChange($event)"
        [nzScroll]="{ x: '1100px' }">
        <thead>
        <tr>
          <th nzWidth="100px">{{ 'itineraries.viewStatusLog.table.status' | transloco }}</th>
          <th nzWidth="200px">{{ 'itineraries.viewStatusLog.table.changedBy' | transloco }}</th>
          <th nzWidth="300px">{{ 'itineraries.viewStatusLog.table.remarks' | transloco }}</th>
          <th nzWidth="150px" [nzSortFn]="sortColumn.compareDate">{{ 'itineraries.viewStatusLog.table.updatedAt' | transloco }}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of basicTable.data">
          <td class="capitalize">{{ getStatusKey(data.status) }}</td>
          <td class="capitalize">{{ data.changedBy }}</td>
          <td> {{ data.statusRemarks ? data.statusRemarks : ('itineraries.viewStatusLog.emptyValue' | transloco) }}</td>
          <td>{{ data.createdAt | date }}</td>
        </tr>
        </tbody>
      </nz-table>
    </div>
  </section>
</nz-spin>
